import type { DecorationWidgetConfig } from '../../types'

export const widgetConfig: DecorationWidgetConfig = {
  type: 'update-popup',
  name: '版本更新',
  icon: '更',
  group: '运营组件',
  description: '配置客户端版本更新提示、更新说明和跳转动作。',
  defaultProps: {
    enabled: false,
    version: '2.3.0',
    title: '国学 App 新版本',
    content: '动态装修、直播连麦与消息体验已升级',
    buttonText: '立即体验',
    dismissText: '稍后',
    link: ''
  }
}
